import RadioButtonField from "../../Utils/RadioButtonField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
import EditorField from "../../Utils/EditorField"
const InterpersonalSkills = ({ formik }) => {
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <RadioButtonField
          label={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_1.label
          }
          value={formik.values.interpersonalSkills_1}
          setValue={formik.setFieldValue}
          valueName={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_1.value
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.interpersonalSkills_2}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_2.value
          }
          label={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_2.label
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.interpersonalSkills_3}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_3.value
          }
          label={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_3.label
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.interpersonalSkills_4}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_4.value
          }
          label={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_4.label
          }
        />
      </div>
      <div style={{ marginTop: "30px" }}>
        <EditorField
          value={formik.values.interpersonalSkills_5}
          onTextChange={formik.setFieldValue}
          valueName={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_5.value
          }
          label={
            careerProfileLabels.interpersonalSkills.interpersonalSkills_5.label
          }
        />
      </div>
    </>
  )
}
export default InterpersonalSkills
